import React from 'react';
import { Button, Form } from 'react-bootstrap';
import style from "../Perfil.module.css";
import { Alert, updateUser } from "../../../utils";
import { FiEdit2 } from "react-icons/fi";
import { IoSaveOutline } from "react-icons/io5";

const ProfileContactSection = ({ email, setEmail, firstName, setFirstName, lastName, setLastName, fechaNacimiento, setFechaNacimiento, numeroSocio, editMode, setEditMode }) => {
  const handleChangeProfileData = (e) => {
    if (e.target.name === "name") {
      setFirstName(e.target.value);
    }

    if (e.target.name === "lastName") {
      setLastName(e.target.value);
    }
    if(e.target.name === "fechaNacimiento"){
      setFechaNacimiento(e.target.value);
    }
  };

  const handleSwitchEditMode = (e) => {
    e.preventDefault();
    setEditMode(!editMode);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nombre = e.target.name.value;
    const apellido = e.target.lastName.value;
    const fechaNacimiento = e.target.fechaNacimiento.value;

    if (nombre === "" || apellido === "" || fechaNacimiento === "") {
      return Alert.error("Completar todos los campos");
    }

    const usuarioEditado = {
      name: nombre,
      lastName: apellido,
      fechaNacimiento : fechaNacimiento
    };

    try {
      await updateUser(email, usuarioEditado);
      Alert.success("Los cambios han sido guardados");
      setEditMode(false);
    } catch (error) {
      Alert.error("Ocurrió un error, intente más tarde nuevamente");
      console.log(error);
    }
  };

  return (
    <>
      <h3 className={`mb-4 ${style.sectionTitle}`}>Datos de contacto</h3>
      <Form onSubmit={handleSubmit}>
        <Form.Control
          label="Email Address"
          name="email"
          value={email}
          type="email"
          placeholder="Enter email"
          className="mb-4"
          disabled={true}
        />

        <Form.Control
          label="First Name"
          name="name"
          value={firstName}
          onChange={handleChangeProfileData}
          type="text"
          placeholder="Ingresar nombre"
          className="mb-4"
          disabled={!editMode}
        />

        <Form.Control
          label="Last Name"
          name="lastName"
          value={lastName}
          onChange={handleChangeProfileData}
          type="text"
          placeholder="Ingresar apellido"
          className="mb-4"
          disabled={!editMode}
        />

        <Form.Control
          label="Fecha Nacimiento"
          name="fechaNacimiento"
          value={fechaNacimiento}
          onChange={handleChangeProfileData}
          type="date"
          placeholder="Ingresar fecha de nacimiento"
          className="mb-4"
          disabled={!editMode}
        />

        <Form.Control
          label="Número de Socio"
          name="numeroSocio"
          value={numeroSocio}
          type="text"
          placeholder="Ingresar número de socio"
          className="mb-4"
          disabled={true}
        />

        <Button
          variant="outline-dark"
          type={!editMode ? "button" : "submit"}
          onClick={(e) => !editMode && handleSwitchEditMode(e)}
          className={style.profileBtns}
        >
          {!editMode ? 
            <>
              <FiEdit2 /> Editar información personal
            </>
          : 
            <>
              <IoSaveOutline /> Guardar cambios
            </>
          }
        </Button>
      </Form>
    </>
  )
}

export default ProfileContactSection;